import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const fetchBusinessUsers = (
  businessUnitObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  config.params.page = (businessUnitObject.page || 0) + 1;
  businessUnitObject.limit && (config.params.limit = businessUnitObject.limit);

  return axiosAuth.get(API_PATH().apis.businessUsers, config);
};

export const getUserDetails = (): Promise<AxiosResponse> => {
  const authToken = localStorage.getItem("token");
  if (!authToken) {
    return Promise.reject("Auth token is not available.");
  }
  return axiosAuth.get(API_PATH().apis.userDetails);
};

export const checkUserAssociation = (
  userId: number,
  companyId: number | null,
  businessUnitId: number | null
) => {
  let config: AxiosRequestConfig = {
    params: {
      userId,
      companyId,
      businessUnitId,
    },
  };
  return axiosAuth.get(API_PATH().apis.checkUserAssociation, config);
};

export const fetchEmployeesCount = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };

  return axiosAuth.get(API_PATH().apis.employeesCount, config);
};
